import { plainToInstance } from 'class-transformer'
import { Entity } from '../entity'
import { ITimeRangeProjectAnalytics } from './ITimeRangeProjectAnalytics.'

export class TimeRangeProjectAnalytics extends Entity<ITimeRangeProjectAnalytics> {
  count: number
  percentageChange: number

  public static new(payload: unknown): TimeRangeProjectAnalytics {
    const entity = plainToInstance(TimeRangeProjectAnalytics, payload)

    return entity
  }

  public getChipLabel() {
    if (this.percentageChange === 0) {
      return '0%'
    } else if (!this.percentageChange) {
      return '-%'
    } else if (this.percentageChange > 0) {
      return `+${this.percentageChange}%`
    } else {
      return `${this.percentageChange}%`
    }
  }

  public getChipColor() {
    if (!this.percentageChange) {
      return 'default'
    } else if (this.percentageChange > 0) {
      return 'success'
    } else {
      return 'error'
    }
  }
}
